import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import Spinner from '@components/atoms/spinner/spinner';
import clsx from 'clsx';
import styles from './alert-deletion-modal.module.scss';

// TODO: Fix ui glitch with spinner when clicking on confirm CTA

export type AlertDeletionModalProps = {
  onClose: () => void;
  deleteConfirm: () => void;
  modalDialogTitleId?: string;
};

const AlertDeletionModal: React.FC<AlertDeletionModalProps> = (props): React.JSX.Element => {
  const { onClose, deleteConfirm, modalDialogTitleId } = props;

  const { t } = useTranslation();

  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const deleteHandler = (): void => {
    setIsDeleting(true);
    deleteConfirm();
  };

  return (
    <div className={styles.alertDeletion}>
      <h2
        className={clsx(styles.alertDeletion__content, 'vc-title-xs')}
        id={modalDialogTitleId}
      >
        {t('ALERTS.MANAGEMENT.DELETE.CONFIRMATION_CONTENT')}
      </h2>
      <div className={styles.alertDeletion__buttons}>
        <Button
          data-cy="delete-alert-cancel-button"
          variant="secondary"
          size="large"
          fullWidth
          notFullWidthQuery="md-up"
          className={styles.alertDeletion__discardBtn}
          onClick={onClose}
        >
          {t('ALERTS.MANAGEMENT.DELETE.CONFIRMATION_CANCEL')}
        </Button>
        <Button
          data-cy="delete-alert-confirm-button"
          disabled={isDeleting}
          variant="primary"
          size="large"
          fullWidth
          notFullWidthQuery="md-up"
          onClick={deleteHandler}
        >
          {isDeleting ? (
            <Spinner className={styles.alertDeletion__buttons__confirmLoading} />
          ) : (
            <>{t('ALERTS.MANAGEMENT.DELETE.CONFIRMATION_CONFIRM_OK')}</>
          )}
        </Button>
      </div>
    </div>
  );
};

export default AlertDeletionModal;
